import React from 'react';
import { motion } from 'framer-motion';

import { Card, CardMedia, CardContent, Typography, Button } from '@mui/material';

import { posCardStyles } from '../style/style';

const IntegrationCard = ({
    name,
    logo,
    tourId,
    onClick,
    description,
    isConnected,
    setCurrentStep,
}) => {
    const classes = posCardStyles();

    return (
        <motion.div whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.98 }}>
            <Card
                sx={classes.card}
                onClick={() => {
                    onClick(name);
                    if (name === 'SkyBox' && window.runTour) {
                        setCurrentStep(1);
                    }
                }}
                data-tour={tourId}
            >
                <CardMedia component="img" image={logo} title={name} sx={classes.logo} />
                <CardContent xs={classes.cardContent}>
                    <Typography variant="h6" marginBottom="10px">
                        {name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" marginBottom="10px">
                        {description}
                    </Typography>
                    <Button
                        size="small"
                        variant="outlined"
                        data-tour={name === 'SkyBox' ? 'skybox-connect-button' : ''}
                        sx={classes.connectButton}
                    >
                        {isConnected ? 'Update' : 'Connect'}
                    </Button>
                </CardContent>
            </Card>
        </motion.div>
    );
};

export default IntegrationCard;
